import { render, staticRenderFns } from "./integralGoodsItemAdd.vue?vue&type=template&id=aa89f9c8&scoped=true&"
import script from "./integralGoodsItemAdd.vue?vue&type=script&lang=js&"
export * from "./integralGoodsItemAdd.vue?vue&type=script&lang=js&"
import style0 from "./integralGoodsItemAdd.vue?vue&type=style&index=0&id=aa89f9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89f9c8",
  null
  
)

export default component.exports